import { Tier } from '@mondaygpt/constants'
import type { Package } from '@revenuecat/purchases-js'
import type { BillingPeriod } from '../components/PlanPicker'
import { hasFreeTrial } from './plan-pricing'

export interface CheckoutProperties {
  plan_name: 'Pro' | 'Business'
  billing_period: 'monthly' | 'yearly'
  price: number
  currency: string
  includes_trial: boolean
}

const TIER_TO_PLAN_NAME: Record<string, 'Pro' | 'Business'> = {
  [Tier.Pro]: 'Pro',
  [Tier.Business]: 'Business',
}

export function getCheckoutProperties(
  pkg: Package | null,
  tier: Tier,
  period: BillingPeriod
): CheckoutProperties {
  const micros = pkg?.webBillingProduct?.price?.amountMicros ?? 0
  const currency = pkg?.webBillingProduct?.price?.currency ?? 'USD'

  return {
    plan_name: TIER_TO_PLAN_NAME[tier] ?? 'Pro',
    billing_period: period,
    price: micros / 1_000_000,
    currency,
    // RC strips the trial phase per customer; a stripped yearly purchase is a
    // real immediate charge, and downstream pixel mapping (StartTrial vs
    // Subscribe) must reflect that. Null package = offering unavailable —
    // fall back to the historical period heuristic.
    includes_trial: period === 'yearly' && (pkg ? hasFreeTrial(pkg) : true),
  }
}
